export const FETCH_ADVERTISERS = 'advertisers/FETCH_ADVERTISERS'
export const CREATE_ADVERTISER = 'advertisers/CREATE_ADVERTISER'
export const UPDATE_ADVERTISER = 'advertisers/UPDATE_ADVERTISER'
export const CLEAR_ADVERTISERS_STATE = 'advertisers/CLEAR_ADVERTISERS_STATE'
